import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    wrapper: {
        width: 'max-content',
        height: 'auto',
        ...STATE_TOKENS.wrapper,
    },
    textCountContainer: {
        ...STATE_TOKENS.textCountContainer,
    },
    letfText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_neutral_font_150,
        ...STATE_TOKENS.letfText,
    },
    rightText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_150,
        ...STATE_TOKENS.rightText,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ["FOCUSED" /* TextCountStateType.FOCUSED */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["FOCUSED" /* TextCountStateType.FOCUSED */] }),
    },
    ["EMPTY" /* TextCountStateType.EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["EMPTY" /* TextCountStateType.EMPTY */] }),
    },
    ["FILLED" /* TextCountStateType.FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["FILLED" /* TextCountStateType.FILLED */] }),
    },
    ["ERROR_EMPTY" /* TextCountStateType.ERROR_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["ERROR_EMPTY" /* TextCountStateType.ERROR_EMPTY */] }),
    },
    ["ERROR_FILLED" /* TextCountStateType.ERROR_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS["ERROR_FILLED" /* TextCountStateType.ERROR_FILLED */] }),
    },
    ["DISABLED_EMPTY" /* TextCountStateType.DISABLED_EMPTY */]: {
        ...commonStateStyles(FOUNDATIONS, {
            letfText: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
            },
            rightText: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
            },
            ...STATE_TOKENS["DISABLED_EMPTY" /* TextCountStateType.DISABLED_EMPTY */],
        }),
    },
    ["DISABLED_FILLED" /* TextCountStateType.DISABLED_FILLED */]: {
        ...commonStateStyles(FOUNDATIONS, {
            letfText: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            rightText: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            ...STATE_TOKENS["DISABLED_FILLED" /* TextCountStateType.DISABLED_FILLED */],
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map